
export const servicesTiny = [
    {
        title : {
            "en" : "Documents",
            "fr" : "Documents",
            "ar" : "وثائق",
        },
        content : {
            "en" : "Delivery of documents (B to B) and (B to C)",
            "fr" : "Livraison des documents (B to B) et (B to C)",
            "ar" : "تسليم المستندات (من B إلى B) و (من B إلى C)",
        },
        icon : 'bx bx-folder',
    },
    {
        title : {
            "en" : "Goods",
            "fr" : "Marchandises",
            "ar" : "بضائع",
        },
        content : {
            "en" : "Delivery of light and heavy goods",
            "fr" : "Livraison des marchandises léger et lourd",
            "ar" : "توصيل البضائع الخفيفة والثقيلة",
        },
        icon : 'bx bx-package',
    },
    {
        title : {
            "en" : "Payment",
            "fr" : "Paiement",
            "ar" : "دفع",
        },
        content : {
            "en" : "Pay securely by Edahabia, CIB or Cash",
            "fr" : "Payer par Edahabia , CIB ou Cash en toute sécurité",
            "ar" : "ادفع بأمان عن طريق Edahabia أو CIB أو نقدًا",
        },
        icon : 'bx bx-wallet',
    },
]

export const servicesBig = [
    {
        title : {
            "en" : "Real-time tracking",
            "fr" : "Suivi en temps réel",
            "ar" : "التتبع في الوقت الحقيقي",
        },
        content : {
            "en" : "Your customers automatically receive notifications upon delivery with smart routing",
            "fr" : "Vos clients reçoivent automatiquement des notifications lors de la livraison avec un routage intelligent",
            "ar" : "يتلقى عملاؤك إشعارات تلقائيًا عند التسليم ",
        },
        icon : 'bx bx-timer',
    },
    {
        title : {
            "en" : "Advanced analytics",
            "fr" : "Analyses avancées",
            "ar" : "التحليلات المتقدمة",
        },
        content : {
            "en" : "Track key metrics and use dashboards to monitor our deliveries",
            "fr" : "Suivez les indicateurs clés et utilisez des tableaux de bord pour surveiller performances de nos livreurs",
            "ar" : "تتبع المقاييس الرئيسية واستخدام لوحات المعلومات لمراقبة أداء سائقي التوصيل لدينا",
        },
        icon : 'bx bx-analyse',
    },
]

export const boxes = [
    {
        sub_title : {
            "en" : "Speed ​​and reliability",
            "fr" : "Rapidité et fiabilité",
            "ar" : "السرعة والموثوقية",
        },
        title : {
            "en" : "Trusted Delivery Platform",
            "fr" : "Plateforme de livraison de confiance",
            "ar" : "منصة توصيل موثوقة",
        },
        content : {
            "en" : "NW Express enables its customers to easily grow their business while maintaining speed of operations and reliability of services.",
            "fr" : "NW Express permet à ses clients de développer facilement leur activité tout en maintenant la rapidité des opérations et la fiabilité des services.",
            "ar" : "تتيح شركة NW Express لعملائها تنمية أعمالهم بسهولة مع الحفاظ على سرعة العمليات وموثوقية الخدمات.",
        },
        link : {
            "en" : "Start Now",
            "fr" : "Commencez Maintenant",
            "ar" : "ابدأ الآن",
        },
        image : "images/img-3.jpg"
    },
    {
        sub_title : {
            "en" : "Real-time tracking",
            "fr" : "Suivi en temps réel",
            "ar" : "التتبع في الوقت الحقيقي",
        },
        title : {
            "en" : "Set flexible on-demand or scheduled deliveries",
            "fr" : "Mettez des livraisons flexibles à la demande ou programmées",
            "ar" : "تعيين عمليات تسليم مرنة حسب الطلب أو مجدولة",
        },
        content : {
            "en" : "Automate shipping, track couriers in real-time from anywhere, and allow customers to leave instant feedback on their delivery experience.",
            "fr" : "Automatisez les expéditions, suivez les coursiers en temps réel où que vous soyez et permettez aux clients de laisser des commentaires instantanés sur leur expérience de livraison.",
            "ar" : "أتمتة الشحن، وتتبع شركات الشحن في الوقت الحقيقي من أي مكان، والسماح للعملاء بترك تعليقات فورية حول تجربة التسليم الخاصة بهم.",
        },
        link : {
            "en" : "Start Tracking",
            "fr" : "Commencez le Suivi",
            "ar" : "بدء التتبع",
        },
        image : "images/img-6.jpg"
    },
    {
        sub_title : {
            "en" : "Keep all records of your work",
            "fr" : "Conservez tous les enregistrements de votre travail",
            "ar" : "احتفظ بجميع سجلات عملك",
        },
        title : {
            "en" : "Call all your deliveries easily",
            "fr" : "Appelez toutes vos livreurs facilement",
            "ar" : "اتصل بكل موظفي التوصيل لديك بسهولة",
        },
        content : {
            "en" : "Organize your deliveries and operational data. Gain valuable insights with our advanced analytics and reporting.",
            "fr" : "Organisez vos livraisons et vos données opérationnelles. Obtenez des informations précieuses grâce à nos analyses et rapports avancés.",
            "ar" : "نظّم عمليات التسليم والبيانات التشغيلية لديك. احصل على رؤى قيّمة بفضل تحليلاتنا وتقاريرنا المتقدمة.",
        },
        link : {
            "en" : "Start Now",
            "fr" : "Commencez Maintenant",
            "ar" : "ابدأ الآن",
        },
        image : "images/img-1.jpg"
    },
    {
        sub_title : {
            "en" : "Automatic connection",
            "fr" : "Connexion automatique",
            "ar" : "اتصال تلقائي",
        },
        title : {
            "en" : "Quick integration with your data",
            "fr" : "Intégration rapide avec vos données",
            "ar" : "التكامل السريع مع بياناتك",
        },
        content : " ",
        content : {
            "en" : "Connect to your existing systems in just minutes, enabling seamless integration and rapid route optimization.",
            "fr" : "Connectez-vous à vos systèmes existants en quelques minutes seulement, permettant une intégration transparente et une optimisation rapide des itinéraires.",
            "ar" : "قم بالاتصال بأنظمتك الحالية في دقائق معدودة، مما يتيح لك التكامل السلس وتحسين المسار السريع.",
        },
        link : "",
        image : "images/shipday.png"
    },
]

       
export const questions = [
    {
        title : "Accordion Heading One",
        content : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages"
    },
    {
        title : "Accordion Heading Two",
        content : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
        title : "Accordion Heading Three",
        content : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
        title : "Accordion Heading Fourth",
        content : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages",
    },
    {
        title : "Accordion Heading Five",
        content : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
        title : "Accordion Heading Sixth",
        content : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
]